import { t } from 'app/i18l'
import { ProcessingView } from 'shared/components/processing'
import { useMemberListProgressContext } from '../progress_context'

export function ProcessingMemberListView() {
  const { progress } = useMemberListProgressContext()

  return (
    <ProcessingView
      progress={progress}
      title={t('loadingMembers')}
      description={t('loadingRecipientsText')}
      iconName="users"
      iconType="font-awesome-5"
      solid
      downloadingText={t('downloadingMembers')}
      processingText={t('loadingMemberProgress', {
        current: progress.current,
        total: progress.total,
      })}
    />
  )
}
